export const HIDE_SERVICE_INTERNAL_ID = 'hide_service';
export const HIDE_RETURN_INTERNAL_ID = 'hide_return';

export const experimentsConfig = [
  {
    name: HIDE_SERVICE_INTERNAL_ID,
    groups: [{ name: 'A', weight: 1 }],
    trafficPercentRange: 1,
  },
  {
    name: HIDE_RETURN_INTERNAL_ID,
    groups: [{ name: 'A', weight: 1 }],
    trafficPercentRange: 1,
  },
];
